import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import LandingPage from "./page/LandingPage";
import PropertyEstimate from "./page/PropertyEstimate";

const App = () => {
  const [isGoogleReady, setIsGoogleReady] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google) {
        setIsGoogleReady(true);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  if (!isGoogleReady)
    return (
      <div className="fixed top-0 right-0 left-0 bottom-0 flex flex-col justify-center items-center">
        <div className="loader"></div>
      </div>
    );

  return (
    <Routes>
      <Route path="/:agent/property-estimate" element={<PropertyEstimate />} />
      <Route path="/property-estimate" element={<PropertyEstimate />} />
      <Route path="/:agent" element={<LandingPage />} />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
};

export default App;
